/**
 * The known keys for domain preferences.
 *
 * ALERTS_SOURCE: Which events to display in the alerts screen.
 */
export const DomainPreferences = {
  ALERTS_SOURCE: 'alerts_source',
  HIDE_IDENTITIES_WITHOUT_IMAGES: 'credentials_hide_no_image',
}

/**
 * Alerts source
 * FACES: Elopement risk alerts.
 * OBJECTS: Object alerts.
 */
export const AlertsSource = {
  FACES: 'faces_elopement_alerts',
  OBJECTS: 'objects',
  MASKS: 'mask_alerts',
  SPLIT: 'split', // depracated
}

// Default preferences
export const DEFAULT_PREFERENCES = {
  [DomainPreferences.ALERTS_SOURCE]: `${AlertsSource.OBJECTS}`,
  [DomainPreferences.HIDE_IDENTITIES_WITHOUT_IMAGES]: false,
}
